const FixedHeader = {
  setHeaderPosition: function() {
    if ($(window).scrollTop() > 25) {
      $('.page-home header').addClass('fixed');
      $('.page-home header').removeClass('not-fixed');
    } else {
      $('.page-home header').removeClass('fixed');
      $('.page-home header').addClass('not-fixed');
    }
  },
  init: function() {
    var _this = this;

    $(window).scroll(function (event) {
     _this.setHeaderPosition();
    });

    $(window).on('load', _this.setHeaderPosition)
  }
}

export default FixedHeader;
